import { CityPreset, TouchConfig } from '../types/types';
import { DEFAULT_ZOOM } from './mapUtils';

export const APP_CONFIG = {
  API_DEBOUNCE_TIME: 2000,
  CACHE_DURATION: 5 * 60 * 1000,
  MAX_CACHE_ENTRIES: 5,
  MAX_API_DAYS_RANGE: 7,
  GPS_UPDATE_INTERVAL: 120000, // 2 minutes
  GPS_RATE_LIMIT: 60000, // 1 minute
} as const;

export const INITIAL_DATE: Date = (() => {
  const today = new Date();
  return new Date(today.getFullYear(), today.getMonth(), today.getDate());
})();

export const DEFAULT_CATEGORIES = ['active', 'music', 'event', 'pop-up'];

export const FORM_URL = 'https://airtable.com/appyVYLljm4C1S0FQ/pagguCGASCniLxYCT/form';

export const GHOST_URL = 'https://behind-the-ceen.ghost.io';

export const SIGN_UP_SHEET = 'https://airtable.com/appNn07L5dZynLTVJ/pagrx3fctM2Pul3rw/form';

// Delay before hiding refresh UI elements (in milliseconds)
export const HIDE_DELAY_MS = 8000;

export const MAX_ACCUMULATED_VENDORS = 500;

// Constants for touch area enhancement
export const TOUCH_CONFIG: TouchConfig = {
  MIN_TOUCH_SIZE: 44, // iOS guideline minimum
  DEBUG_MODE: process.env.NODE_ENV === 'development', // Show debug areas in dev
  COLLISION_THRESHOLD: 4, // px overlap before triggering disambiguation
  ZOOM_INCREMENT: 1.5, // How much to zoom when disambiguating
  MAX_DISAMBIGUATION_ZOOM: 18, // Don't zoom past this level
};

export const MAP_EASE_TO_DURATION = 500; // Duration for map easeTo animations in milliseconds

export const CITY_PRESETS: CityPreset[] = [
  {
    id: 'oakland',
    name: 'Oakland',
    lat: 37.8044,
    lng: -122.2712,
    zoom: DEFAULT_ZOOM,
    bounds: { north: 37.885, south: 37.724, east: -122.114, west: -122.355 },
  },
  {
    id: 'goa',
    name: 'Goa',
    lat: 15.4935,
    lng: 73.7905,
    zoom: DEFAULT_ZOOM,
    bounds: { north: 15.812, south: 14.894, east: 74.368, west: 73.68 },
  },
];

export const LAST_CITY_KEY = 'ceen_last_city';
export const UNVERIFIED_PIN_COUNT_KEY = 'ceen_unverified_pin_count';
